import React from 'react';
import { motion } from 'framer-motion';
import { BedDouble, Wifi, Flame, Car, Coffee, Waves, Droplets, ThermometerSun, Snowflake, Gamepad2, Mountain } from 'lucide-react';
const services = [{
  icon: <BedDouble size={24} data-id="element-223" />,
  name: 'Ropa blanca incluida'
}, {
  icon: <Wifi size={24} data-id="element-224" />,
  name: 'Wi‑Fi'
}, {
  icon: <Flame size={24} data-id="element-225" />,
  name: 'Parrilla individual'
}, {
  icon: <Car size={24} data-id="element-226" />,
  name: 'Cochera'
}, {
  icon: <Coffee size={24} data-id="element-227" />,
  name: 'Desayuno buffet'
}, {
  icon: <ThermometerSun size={24} data-id="element-228" />,
  name: 'Calefacción'
}, {
  icon: <Snowflake size={24} data-id="element-229" />,
  name: 'Refrigeración'
}, {
  icon: <Gamepad2 size={24} data-id="element-230" />,
  name: 'Salón de juegos'
}, {
  icon: <Mountain size={24} data-id="element-231" />,
  name: 'Desayunador con vista'
}, {
  icon: <Waves size={24} data-id="element-232" />,
  name: 'Tres piscinas climatizadas de noviembre a marzo'
}];
export function Services() {
  return <section id="servicios" className="py-24 bg-sand-light" data-id="element-233">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-234">
        <div className="text-center max-w-3xl mx-auto mb-14" data-id="element-235">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl text-olive-dark mb-6" data-id="element-236">
            Todo lo que necesitás para disfrutar tu estadía
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-charcoal-light" data-id="element-237">
            En Cabañas El Mirador cuidamos cada detalle para que vivas una
            experiencia cómoda, relajada y completa, rodeado de naturaleza y con
            servicios pensados para tu descanso.
          </motion.p>
        </div>

        {/* Desktop/Tablet Grid */}
        <div className="hidden sm:grid sm:grid-cols-3 lg:grid-cols-5 gap-4 max-w-5xl mx-auto" data-id="element-238">
          {services.map((service, index) => <motion.div key={`desktop-${index}`} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.04
        }} className="bg-white p-4 rounded-xl shadow-sm border border-sand flex flex-col items-center text-center gap-3 hover:shadow-md transition-shadow" data-id="element-239">
              <div className="text-earth bg-sand p-3 rounded-full" data-id="element-240">
                {service.icon}
              </div>
              <span className="text-sm font-medium text-charcoal leading-tight" data-id="element-241">
                {service.name}
              </span>
            </motion.div>)}
        </div>

        {/* Mobile Flex (4 per row, last 3 centered) */}
        <div className="flex sm:hidden flex-wrap justify-center gap-2" data-id="element-242">
          {services.map((service, index) => <motion.div key={`mobile-${index}`} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.04
        }} className="bg-white p-2 rounded-xl shadow-sm border border-sand flex flex-col items-center text-center gap-2 w-[23%]" data-id="element-243">
              <div className="text-earth bg-sand p-2 rounded-full scale-75" data-id="element-244">
                {service.icon}
              </div>
              <span className="text-[10px] font-medium text-charcoal leading-tight" data-id="element-245">
                {service.name}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}